import { render, staticRenderFns } from "./talkdesk.vue?vue&type=template&id=05aba1c0&scoped=true&"
import script from "./talkdesk.vue?vue&type=script&lang=js&"
export * from "./talkdesk.vue?vue&type=script&lang=js&"
import style0 from "./talkdesk.vue?vue&type=style&index=0&id=05aba1c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05aba1c0",
  null
  
)

export default component.exports